module.exports = "/images/logo-alertmedia.svg?3bc51d13e379a9a29f4362f6d0e5eeb6";